import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    isShown: false,
    loading: false,
    importProcess: false,
    holidays: [],
    hasHolidaysInPast: false,
    year: '',
    country: '',
    fileName: '',
}

export default handleActions({
    [ActionTypes.OPEN_PANEL]: (state) => ({
        ...state,
        isShown: true,
    }),
    [ActionTypes.CLOSE_PANEL]: (state) => ({
        ...state,
        isShown: false,
    }),
    [ActionTypes.YEAR_SET]: (state, {payload: year}) => ({
        ...state,
        year,
    }),
    [ActionTypes.COUNTRY_SET]: (state, {payload: country}) => ({
        ...state,
        country,
    }),
    [ActionTypes.HOLIDAYS_SET]: (state, {payload: holidays}) => ({
        ...state,
        holidays,
    }),
    [ActionTypes.HOLIDAYS_IN_PAST_SET]: (state, {payload: hasHolidaysInPast}) => ({
        ...state,
        hasHolidaysInPast,
    }),
    [ActionTypes.LOAD_DATA]: (state) => ({
        ...state,
        loading: true,
    }),
    [ActionTypes.LOAD_DATA_SUCCESS]: (state, {payload: {holidays, hasHolidaysInPast, country = null, fileName = null}}) => ({
        ...state,
        loading: false,
        holidays,
        hasHolidaysInPast,
        country,
        fileName,
    }),
    [ActionTypes.LOAD_DATA_FAILURE]: (state) => ({
        ...state,
        loading: false,
        isShown: false,
        country: null,
        fileName: null,
    }),
    [ActionTypes.IMPORT_HOLIDAYS_START]: (state) => ({
        ...state,
        importProcess: true,
    }),
    [ActionTypes.IMPORT_HOLIDAYS_COMPLETE]: (state) => ({
        ...state,
        importProcess: false,
        isShown: false,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/reducer.js